import API from '@services/API';
import KeycloakService from '@services/keycloakService';
import { setError, startSpinner, stopSpinner } from '@actions/common/actionCreators';
import { DMI_ACTION_TYPES } from '@constants/actionTypes/dmiVerificationActionTypes';
import { configs } from '@constants/configs/configs';

export const setDmiVerificationsData = data => ({
    type: DMI_ACTION_TYPES.GET_DMI_VERIFICATIONS_DATA,
    payload: data,
});

export const setDmiVlpVerificationsData = data => ({
    type: DMI_ACTION_TYPES.GET_DMI_VLP_VERIFICATIONS_DATA,
    payload: data,
});

export const setDmiUserViewRef = data => ({
    type: DMI_ACTION_TYPES.GET_CURRENT_USER_VIEWREF,
    payload: data,
});

export const setHouseholdIncome = data => ({
    type: DMI_ACTION_TYPES.GET_HOUSEHOLD_INCOME,
    payload: data,
});

export const setUploadedDocuments = data => ({
    type: DMI_ACTION_TYPES.UPLOAD_VERIFICATION_DOCUMENTS,
    payload: data,
});

export const updateDocumentCategoryDetailList = (selectedIndex, newDetailList) => ({
    type: DMI_ACTION_TYPES.UPDATE_DOCUMENT_CATEGORY_DETAIL_LIST,
    payload: {
        selectedIndex,
        newDetailList,
    },
});

const actions = { setError, startSpinner, stopSpinner };

export const fetchDmiVerificationsData = (url, _environment) => async dispatch => {
    const data = await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setDmiVerificationsData({ ...data }));
    } else {
        // Main DMI dashboard data is required to render the page; 
        // If this fetch fails for any reason (4xx, 5xx, network), show generic Fallback page
        console.error('Cannot get dmi verifications data', url);
        window.location.href = configs.routes.FALLBACK;
    }
};


export const fetchDmiVlpVerificationsData = (url, payload) => async dispatch => {
    const data = global.__ENV__.PRODUCTION
        ? await API.postData([url, payload], dispatch, actions)
        : await API.getData(url, dispatch, actions, true);

    if (data && data.vlpVerifications) {
        const responseArray = Object.entries(data.vlpVerifications);
        const result = responseArray.sort((a, b) => {
            const aDate = new Date(a[1]?.step1Verifications?.[0]?.timestamp);
            const bDate = new Date(b[1]?.step1Verifications?.[0]?.timestamp);
            return aDate > bDate ? -1 : 1;
        });
        const resultArray = [];
        result.forEach((v) => {
            const obj = {};
            obj[v[0]] = v[1];
            resultArray.push(obj);
        });

        dispatch(setDmiVlpVerificationsData({ vlpDetails: resultArray, applicantGuid: payload.applicantGuid }));
    } else {
        console.error('Cannot get dmi vlp verifications data', url);
    }
};

export const fetchCurrentUserViewRef = _environment => async dispatch => {
    const data = await API.getData(configs.endpoints.RIDP_VIEWREF_ENDPOINT, dispatch, actions, true);
    if (data) {
        dispatch(setDmiUserViewRef(data.viewRef));
    } else {
        console.error('Cannot get view ref details', configs.endpoints.RIDP_VIEWREF_ENDPOINT);
    }
};

export const fetchHouseholdIncome = (url, _environment) => async dispatch => {
    const data = await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setHouseholdIncome(data));
    } else {
        console.error('Cannot get household Income details', url);
    }
};

export const uploadVerificationDocuments = (url, payload, callback) => async dispatch => {
    const params = [url, payload, undefined, true, undefined, 'multipart/form-data'];
    const data = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions, true);
    if (data) {
        dispatch(setUploadedDocuments(data));
        callback(data);
    } else {
        console.error('There is an error in submitting document');
    }
};

export const autoVerifyVerificationDocuments = (url, payload, callback) => async dispatch => {
    const authHeader = await KeycloakService.getAuthHeader();
    const params = [url, payload, undefined, true, authHeader, 'multipart/form-data'];
    const data = await API.postData(params, dispatch, actions);
    if (data) {
        dispatch(setUploadedDocuments(data));
        callback(data);
    } else {
        console.error('There is an error in submitting document for auto verification');
    }
};

export const loadUploadedVerificationDocuments = (url, payload, callback) => async dispatch => {
    const params = [url, payload, undefined, false];
    const data = global.__ENV__.PRODUCTION
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions, true);
    if (data) {
        callback(data);
    }
};

export const deleteUploadedVerificationDocuments = (url, callback) => async dispatch => {
    const data = await API.getData(url, dispatch, actions, true);
    if (data) {
        callback(data);
    } else {
        console.error('There is an error in delete the document');
    }
};

export const uploadDocumentUsingQRCode = (url, payload, callback) => async dispatch => {
    const params = [url, payload, undefined, false];

    const data =  global.__ENV__.PRODUCTION 
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions, true);
    if (data) {
        callback(data);
    } else {
        console.error('There is an error in submitting document');
    }
};

export const overrideVerificationStatus = (url, payload, callback) => async dispatch => {
    const {applicantID, documentCategory, overrideComments, caseNumber } = payload;
    const updatedURL = `${url}?applicantID=${applicantID}&documentCategory=${documentCategory}&overrideComments=${overrideComments}&caseNumber=${caseNumber}`;
    const params = [updatedURL, {}, undefined, false];
    const data =  global.__ENV__.PRODUCTION 
        ? await API.postData(params, dispatch, actions)
        : await API.getData(url, dispatch, actions, true);
    if (data) {
        callback(data);
    } else {
        console.error('There is an error in submitting override status');
    }
};